export type Theme = "dark" | "light";

const KEY = "otzem-theme";

export function getTheme(): Theme {
  return (localStorage.getItem(KEY) as Theme) || "dark";
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.classList.remove("dark", "light");
  root.classList.add(theme);
  localStorage.setItem(KEY, theme);
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", theme === "dark" ? "#0f1a1f" : "#ffffff");
}

export function initTheme(): void {
  applyTheme(getTheme());
}
